(function ($) {
  docReady(initAllScripts);

  function docReady(fn: VoidFunction) {
    if (document.readyState !== 'loading') {
      setTimeout(fn, 0);
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  //? Helpers
  function isPresent(selector: string) {
    return !!document.querySelector(selector);
  }

  function initIf(selector: string, initFunction: CallableFunction, args: Array<any> = []) {
    if (isPresent(selector)) initFunction(...args);
  }

  // ? Init all functions
  function initAllScripts() {
    initIf('.header .menu', mobileNavInit);
    initIf('[data-search-button]', searchInit);
    initIf('.feed-item--video', videoFeedInit);
    initIf('[data-scroll-top]', toTopInit);
    initIf('[data-contents]', tableOfContentInit, [90]);
    initIf('[data-m]', modalsInit);
    initIf('[data-video]', toggleVideosInit);
    initIf('#token-response', captchaInit);
  }

  //? Init functions
  function mobileNavInit() {
    const nav = document.querySelector('.header .menu') as HTMLUListElement,
      activationButton = document.querySelector('[data-nav-button]') as HTMLDivElement;

    activationButton.addEventListener('click', function () {
      this.toggleAttribute('data-active');
      nav.toggleAttribute('data-active');
    });
  }

  function searchInit() {
    const searchButton = document.querySelector('[data-search-button]') as HTMLButtonElement;
    const searchInput = document.querySelector('[data-search-input]') as HTMLInputElement;
    const nav = document.querySelector('.header .nav') as HTMLUListElement;

    searchButton.addEventListener('click', function (e) {
      if (!this.hasAttribute('data-active') || searchInput.value === '') e.preventDefault();

      if (searchInput.value.length > 0) return;

      if (!this.hasAttribute('data-active')) searchInput.focus();

      this.toggleAttribute('data-active');
      searchInput.toggleAttribute('data-active');
      nav.toggleAttribute('data-search-active');
    });

    document.addEventListener('click', function (e) {
      if (!searchInput.hasAttribute('data-active')) return;

      const target = e.target as HTMLElement;

      if (
        target === searchButton ||
        target === searchInput ||
        target.parentElement === searchButton ||
        target.parentElement.parentElement === searchButton
      )
        return;

      nav.removeAttribute('data-search-active');
      searchButton.removeAttribute('data-active');
      searchInput.removeAttribute('data-active');
      searchInput.value = '';
    });
  }

  function videoFeedInit() {
    const videoFeeds = document.querySelectorAll('.feed-item--video') as NodeListOf<HTMLAnchorElement>;

    videoFeeds.forEach((videoFeed) => {
      videoFeed.addEventListener('pointerenter', function () {
        this.querySelector('video').play();
      });

      videoFeed.addEventListener('pointerleave', function () {
        this.querySelector('video').currentTime = 0;
        this.querySelector('video').pause();
      });
    });
  }

  function toTopInit() {
    const button = document.querySelector('[data-scroll-top]') as HTMLButtonElement;

    button.addEventListener('click', function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });

    document.addEventListener('scroll', function () {
      if (window.scrollY > window.outerHeight / 2) {
        button.setAttribute('data-visible', '');
      } else {
        button.removeAttribute('data-visible');
      }
    });
  }

  function tableOfContentInit(offset: number) {
    const samePageLinks = document.querySelectorAll('[data-contents] a') as NodeListOf<HTMLAnchorElement>;

    samePageLinks.forEach((anchor) => {
      const scrollTarget = document.querySelector(anchor.getAttribute('href')) as HTMLHeadingElement;
      const elDistanceToTop = window.pageYOffset + scrollTarget.getBoundingClientRect().top;

      anchor.addEventListener('click', function (e) {
        e.preventDefault();

        window.scrollTo({
          top: elDistanceToTop - offset,
          behavior: 'smooth',
        });
      });
    });
  }

  function modalsInit() {
    const buttonsActive = document.querySelectorAll('[data-m-activate]') as NodeListOf<HTMLButtonElement>,
      buttonsDeactivate = document.querySelectorAll('[data-m-deactivate]') as NodeListOf<HTMLButtonElement>;

    buttonsActive.forEach((button) => {
      if (!button.matches('button')) return;

      button.addEventListener('click', function () {
        const numberOfModal = this.dataset.mActivate;
        const modal = document.querySelector(`[data-m="${numberOfModal}"]`) as HTMLElement;

        modal.toggleAttribute('data-active');
      });
    });

    buttonsDeactivate.forEach((button) => {
      const numberOfModal = button.dataset.mDeactivate;
      const modal = document.querySelector(`[data-m="${numberOfModal}"]`) as HTMLElement;

      button.addEventListener('click', function () {
        modal.removeAttribute('data-active');
      });

      modal.addEventListener('click', function (e) {
        if (e.target != modal) return;
        modal.removeAttribute('data-active');
      });
    });
  }

  function toggleVideosInit() {
    const allVideoContainers = document.querySelectorAll('[data-video]') as NodeListOf<HTMLDivElement>;

    allVideoContainers.forEach((videoContainer) => {
      const img = videoContainer.querySelector('img');
      const iframe = videoContainer.querySelector('iframe');

      img.style.height = 'calc(100% - ' + (videoContainer.offsetHeight - iframe.offsetHeight) + 'px)';

      videoContainer.addEventListener('click', function () {
        iframe.src = iframe.src + '?autoplay=1';
        img.toggleAttribute('data-hidden');
        iframe.style.opacity = '1';
      });
    });
  }

  function captchaInit() {
    grecaptcha.ready(function () {
      grecaptcha
        .execute('6LdCpG4hAAAAAOhk54m_-Cls8OCNwINSnZtjO5t2', { action: 'submit' })
        .then(function (token: string) {
          document.querySelector<HTMLInputElement>('#token-response').value = token;
        });
    });
  }
})(jQuery);
